export const HappinessSemicircle = () => {
    return (
        <svg
            viewBox="0 0 234.271 94.2722"
            xmlns="http://www.w3.org/2000/svg"
            width="234.271484"
            height="94.272217"
            fill="none"
        >
            <defs>
                <linearGradient id="paint_custom_gradient_0">
                    <stop stopColor="rgb(255,81,81)" offset="0.0799999982" stopOpacity="1" />
                    <stop stopColor="rgb(253,184,64)" offset="0.25" stopOpacity="1" />
                    <stop stopColor="rgb(59,213,124)" offset="0.419999987" stopOpacity="1" />
                </linearGradient>
                <mask id="outline_mask_0">
                    <path
                        d="M1.22461 89.9418C6.67647 69.5951 17.3881 51.042 32.2829 36.1472L40.7682 44.6325C27.3629 58.0378 17.7224 74.7356 12.8157 93.0476L1.22461 89.9418Z"
                        fill="rgb(255,255,255)"
                        fillRule="nonzero"
                    />
                </mask>

                <linearGradient id="paint_custom_gradient_1">
                    <stop stopColor="rgb(255,81,81)" offset="0.0799999982" stopOpacity="1" />
                    <stop stopColor="rgb(253,184,64)" offset="0.25" stopOpacity="1" />
                    <stop stopColor="rgb(59,213,124)" offset="0.419999987" stopOpacity="1" />
                </linearGradient>
                <mask id="outline_mask_1">
                    <path
                        d="M32.2832 36.1472C47.178 21.2524 65.7311 10.5407 86.0777 5.08887L89.1835 16.68C70.8716 21.5867 54.1738 31.2271 40.7685 44.6324L32.2832 36.1472Z"
                        fill="rgb(255,255,255)"
                        fillRule="nonzero"
                    />
                </mask>

                <linearGradient id="paint_custom_gradient_2">
                    <stop stopColor="rgb(255,81,81)" offset="0.0799999982" stopOpacity="1" />
                    <stop stopColor="rgb(253,184,64)" offset="0.25" stopOpacity="1" />
                    <stop stopColor="rgb(59,213,124)" offset="0.419999987" stopOpacity="1" />
                </linearGradient>
                <mask id="outline_mask_2">
                    <path
                        d="M86.0771 5.08891C106.424 -0.362964 127.847 -0.362969 148.194 5.08889L145.088 16.68C126.776 11.7733 107.495 11.7733 89.183 16.68L86.0771 5.08891Z"
                        fill="rgb(255,255,255)"
                        fillRule="nonzero"
                    />
                </mask>

                <linearGradient id="paint_custom_gradient_3">
                    <stop stopColor="rgb(255,81,81)" offset="0.0799999982" stopOpacity="1" />
                    <stop stopColor="rgb(253,184,64)" offset="0.25" stopOpacity="1" />
                    <stop stopColor="rgb(59,213,124)" offset="0.419999987" stopOpacity="1" />
                </linearGradient>
                <mask id="outline_mask_3">
                    <path
                        d="M148.195 5.08887C168.541 10.5407 187.094 21.2523 201.989 36.1471L193.504 44.6324C180.099 31.2271 163.401 21.5867 145.089 16.68L148.195 5.08887Z"
                        fill="rgb(255,255,255)"
                        fillRule="nonzero"
                    />
                </mask>

                <linearGradient id="paint_custom_gradient_4">
                    <stop stopColor="rgb(255,81,81)" offset="0.0799999982" stopOpacity="1" />
                    <stop stopColor="rgb(253,184,64)" offset="0.25" stopOpacity="1" />
                    <stop stopColor="rgb(59,213,124)" offset="0.419999987" stopOpacity="1" />
                </linearGradient>
                <mask id="outline_mask_4">
                    <path
                        d="M201.988 36.1472C216.883 51.042 227.595 69.595 233.046 89.9417L221.455 93.0475C216.549 74.7355 206.908 58.0378 193.503 44.6325L201.988 36.1472Z"
                        fill="rgb(255,255,255)"
                        fillRule="nonzero"
                    />
                </mask>
            </defs>

            <g id="Group_10">
                <path
                    d="M1.22461 89.9418C6.67647 69.5951 17.3881 51.042 32.2829 36.1472L40.7682 44.6325C27.3629 58.0378 17.7224 74.7356 12.8157 93.0476L1.22461 89.9418Z"
                    fill="rgb(0,0,0)"
                    fillOpacity="0"
                    fillRule="nonzero"
                    data-custom-gradient="url(#custom_gradient_0)"
                />
                <g
                    id="custom_gradient_0"
                    data-angular-gradient="url(#paint_custom_gradient_0); 115.911125 -35.147156 115.911102 84.852814 -4.088867 84.852791"
                    mask="url(#outline_mask_0)"
                >
                    <foreignObject width="39.543560" height="56.900360" x="1.224609" y="36.147217">
                        <div
                            style={{
                                background:
                                    "conic-gradient(from -61.199982deg at 115.911102px 84.852814px, rgba(255,81,81,1) 0%, rgba(253,184,64,1) 17%, rgba(59,213,124,1) 34%, rgba(255,81,81,1) 100%)",
                                width: "100%",
                                height: "100%",
                            }}
                        />
                    </foreignObject>
                </g>

                <path
                    d="M32.2829 36.1472L40.7682 44.6325C27.3629 58.0378 17.7224 74.7356 12.8157 93.0476L1.22461 89.9418C6.67647 69.5951 17.3881 51.042 32.2829 36.1472Z"
                    fillRule="nonzero"
                    stroke="rgb(249,249,250)"
                    strokeWidth="2"
                />

                <path
                    d="M32.2832 36.1472C47.178 21.2524 65.7311 10.5407 86.0777 5.08887L89.1835 16.68C70.8716 21.5867 54.1738 31.2271 40.7685 44.6324L32.2832 36.1472Z"
                    fill="rgb(0,0,0)"
                    fillOpacity="0"
                    fillRule="nonzero"
                    data-custom-gradient="url(#custom_gradient_1)"
                />
                <g
                    id="custom_gradient_1"
                    data-angular-gradient="url(#paint_custom_gradient_1); 84.853020 -4.088943 84.852997 115.911026 -35.146973 115.911003"
                    mask="url(#outline_mask_1)"
                >
                    <foreignObject width="56.900345" height="39.543571" x="32.283203" y="5.088867">
                        <div
                            style={{
                                background:
                                    "conic-gradient(from -61.199982deg at 84.852997px 115.911026px, rgba(255,81,81,1) 0%, rgba(253,184,64,1) 17%, rgba(59,213,124,1) 34%, rgba(255,81,81,1) 100%)",
                                width: "100%",
                                height: "100%",
                            }}
                        />
                    </foreignObject>
                </g>

                <path
                    d="M86.0777 5.08887L89.1835 16.68C70.8716 21.5867 54.1738 31.2271 40.7685 44.6324L32.2832 36.1472C47.178 21.2524 65.7311 10.5407 86.0777 5.08887Z"
                    fillRule="nonzero"
                    stroke="rgb(249,249,250)"
                    strokeWidth="2"
                />

                <path
                    d="M86.0771 5.08891C106.424 -0.362964 127.847 -0.362969 148.194 5.08889L145.088 16.68C126.776 11.7733 107.495 11.7733 89.183 16.68L86.0771 5.08891Z"
                    fill="rgb(0,0,0)"
                    fillOpacity="0"
                    fillRule="nonzero"
                    data-custom-gradient="url(#custom_gradient_2)"
                />
                <g
                    id="custom_gradient_2"
                    data-angular-gradient="url(#paint_custom_gradient_2); 31.058105 -0.000076 31.058083 119.999893 -88.941895 119.999870"
                    mask="url(#outline_mask_2)"
                >
                    <foreignObject width="62.116562" height="15.680016" x="86.077148" y="1">
                        <div
                            style={{
                                background:
                                    "conic-gradient(from -61.199982deg at 31.058083px 119.999893px, rgba(255,81,81,1) 0%, rgba(253,184,64,1) 17%, rgba(59,213,124,1) 34%, rgba(255,81,81,1) 100%)",
                                width: "100%",
                                height: "100%",
                            }}
                        />
                    </foreignObject>
                </g>

                <path
                    d="M148.194 5.08889L145.088 16.68C126.776 11.7733 107.495 11.7733 89.183 16.68L86.0771 5.08891C106.424 -0.362964 127.847 -0.362969 148.194 5.08889Z"
                    fillRule="nonzero"
                    stroke="rgb(249,249,250)"
                    strokeWidth="2"
                />

                <path
                    d="M148.195 5.08887C168.541 10.5407 187.094 21.2523 201.989 36.1471L193.504 44.6324C180.099 31.2271 163.401 21.5867 145.089 16.68L148.195 5.08887Z"
                    fill="rgb(0,0,0)"
                    fillOpacity="0"
                    fillRule="nonzero"
                    data-custom-gradient="url(#custom_gradient_3)"
                />
                <g
                    id="custom_gradient_3"
                    data-angular-gradient="url(#paint_custom_gradient_3); -27.952644 -4.088943 -27.952667 115.911026 -147.952637 115.911003"
                    mask="url(#outline_mask_3)"
                >
                    <foreignObject width="56.90033" height="39.543522" x="145.088867" y="5.088867">
                        <div
                            style={{
                                background:
                                    "conic-gradient(from -61.199982deg at -27.952667px 115.911026px, rgba(255,81,81,1) 0%, rgba(253,184,64,1) 17%, rgba(59,213,124,1) 34%, rgba(255,81,81,1) 100%)",
                                width: "100%",
                                height: "100%",
                            }}
                        />
                    </foreignObject>
                </g>

                <path
                    d="M201.989 36.1471L193.504 44.6324C180.099 31.2271 163.401 21.5867 145.089 16.68L148.195 5.08887C168.541 10.5407 187.094 21.2523 201.989 36.1471Z"
                    fillRule="nonzero"
                    stroke="rgb(249,249,250)"
                    strokeWidth="2"
                />

                <path
                    d="M201.988 36.1472C216.883 51.042 227.595 69.595 233.046 89.9417L221.455 93.0475C216.549 74.7355 206.908 58.0378 193.503 44.6325L201.988 36.1472Z"
                    fill="rgb(0,0,0)"
                    fillOpacity="0"
                    fillRule="nonzero"
                    data-custom-gradient="url(#custom_gradient_4)"
                />
                <g
                    id="custom_gradient_4"
                    data-angular-gradient="url(#paint_custom_gradient_4); -76.367691 -35.147171 -76.367714 84.852806 -196.367691 84.852783"
                    mask="url(#outline_mask_4)"
                >
                    <foreignObject width="39.543549" height="56.900269" x="193.50293" y="36.147217">
                        <div
                            style={{
                                background:
                                    "conic-gradient(from -61.199982deg at -76.367714px 84.852806px, rgba(255,81,81,1) 0%, rgba(253,184,64,1) 17%, rgba(59,213,124,1) 34%, rgba(255,81,81,1) 100%)",
                                width: "100%",
                                height: "100%",
                            }}
                        />
                    </foreignObject>
                </g>

                <path
                    d="M233.046 89.9417L221.455 93.0475C216.549 74.7355 206.908 58.0378 193.503 44.6325L201.988 36.1472C216.883 51.042 227.595 69.595 233.046 89.9417Z"
                    fillRule="nonzero"
                    stroke="rgb(249,249,250)"
                    strokeWidth="2"
                />
            </g>
        </svg>
    );
};
